import React, { useEffect, useRef, useState } from 'react'
import Navigation from '../../components/navigation'
import Footer from '../../components/footer'
import { THEMES } from '../../constatnts'
import Spacer from 'src/components/Spacer'
import PromoBlock from 'src/components/PromoBlock'
import CountUp from 'react-countup'
import { useIsInViewportOnce } from 'src/hooks'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, IconButton, Menu, MenuItem } from '@mui/material'
import { Form } from 'src/components/form'
import { useNavigate } from 'react-router-dom'

const LloydsLogo = ({ style }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    fill='none'
    focusable='false'
    height='43'
    viewBox='0 0 158 43'
    width='158'
    style={style}
  >
    <path
      d='M10.6809 41.9665L9.80894 41.3565C9.43933 36.9607 8.06497 34.2963 7.33652 32.9237C8.11341 32.4106 9.40345 31.2282 9.40345 29.5309C9.40345 27.8336 8.01832 26.9382 8.01832 24.8372C8.01832 23.6782 8.41304 22.7111 9.05717 21.9593C8.63912 21.3618 8.14929 21.0389 7.42085 21.0389C6.60807 21.0389 5.87962 21.7081 5.87962 22.7344C5.87962 23.3319 6.14158 23.9886 6.70316 24.2756C6.29767 24.8372 5.25703 24.8964 4.68468 24.0478H4.67212C4.67212 26.0537 6.79826 27.4514 6.79826 29.5901C6.79826 30.9752 5.7002 32.3137 4.11053 32.3137C2.92815 32.3137 1.81753 31.7647 1.24339 30.6648C2.53342 30.9985 3.46462 30.4854 3.46462 29.3389C3.46462 27.2612 0 25.2176 0 21.683C0 18.9002 2.1387 17.359 4.57523 17.359C6.79646 17.359 8.77906 18.387 10.2736 20.9671C11.038 20.393 11.9692 20.0718 12.9129 19.8798C15.4571 19.3775 18.5754 19.8314 20.9635 18.8159C22.0275 18.3619 22.9102 17.5617 22.9102 16.6413C22.9102 16.1999 22.6591 15.9362 22.3002 15.9362C22.1208 15.9362 21.8463 16.0205 21.6902 16.4134C21.2237 16.0079 21.0802 15.5773 21.0802 15.1467C21.0802 14.4308 21.3062 14.0953 21.5574 13.749C21.3188 13.1282 20.5778 12.9847 20.0754 13.5929C19.4546 12.4464 19.8368 10.8693 21.4498 10.3921V10.3795C19.5623 10.0691 19.0617 8.89927 19.2752 7.59668C19.4546 7.75277 19.6573 7.84787 19.8601 7.84787C20.1705 7.84787 20.3625 7.59668 20.3625 7.23784C20.3625 6.85567 20.1723 6.2582 19.1926 5.60152C20.0521 4.31148 21.5341 4.1195 22.2859 4.59856L22.2984 4.586C21.9163 4.06029 21.7243 3.13986 22.3343 2.232C22.4778 2.43474 22.8241 2.73437 23.3624 2.73437C24.9395 2.73437 24.9987 1.00296 26.2044 0.836101C26.1326 1.37436 26.2762 2.12614 26.9454 2.12614C27.8174 2.12614 28.2229 0.812776 28.4382 0C28.8204 0.215305 29.0949 0.584912 29.0357 1.27748H29.0482L29.5739 0.215305C30.0153 0.584912 30.0996 1.2075 29.9561 1.7673C29.9202 1.91083 29.8718 2.01848 29.8718 2.10102C29.8718 2.51907 31.1259 2.82947 31.1259 3.76066C31.1259 3.91676 31.0775 4.08362 31.0057 4.2738L33.8729 7.89272C34.0523 8.11879 34.1115 8.35922 34.1115 8.56196C34.1115 9.31374 33.4548 10.114 32.5111 10.114C31.5673 10.114 31.2443 9.60081 31.1977 9.36218L28.702 8.14391C28.5584 8.38254 28.3916 8.77727 28.3916 9.21864C28.3916 11.9656 32.2742 12.0373 33.218 15.6329L37.0648 14.3555C39.8117 17.0306 42.7147 19.6233 44.5071 20.6854L45.6411 22.1316H42.2016V21.1286L41.2578 20.8666C39.8117 18.597 37.8542 17.3554 36.8028 17.045C35.5253 17.8219 34.569 18.6329 33.4458 19.887C35.2741 19.7435 37.3159 19.9229 39.024 20.2458L38.1287 27.9269L37.4003 29.8969L35.4661 31.5458V28.1529H36.505L36.2179 27.0782C37.0666 24.8318 37.1742 23.3283 37.1742 22.5155C37.1742 22.2643 37.1616 22.0257 37.0791 21.9414C37.0073 21.8696 36.7095 21.9414 36.4458 22.0131C35.7532 22.2051 34.6175 22.7416 33.1606 23.924C31.8472 24.9987 31.1295 25.4885 29.3497 25.2858C27.3437 27.3635 23.0915 28.3682 19.3631 28.3198C19.076 31.3412 15.7316 33.0852 15.7316 34.5188C15.7316 35.0319 16.2214 35.868 17.2962 37.481C18.4911 39.2734 19.625 40.9923 21.0353 41.5431L22.2302 43H18.7782L18.7549 41.9612L17.7752 41.4229C16.6521 39.3452 14.8973 37.0504 12.4841 34.9009C13.069 33.7311 13.3794 32.5362 13.392 31.4004C12.3047 33.0368 10.7168 33.0493 10.4297 34.2909C10.3221 34.7574 10.3813 35.6653 10.6325 36.8351C11.0021 38.6024 11.3376 40.7052 12.9739 41.518L14.1079 43H10.6791V41.9612L10.6809 41.9665Z'
      fill='black'
    ></path>
    <path
      d='M4.73132 18.3277C5.4472 18.3277 6.46273 18.4946 7.16785 19.1513C5.49565 18.3869 3.01067 18.8893 2.83125 20.9078C2.54417 20.5974 2.44908 20.2152 2.42576 19.8797C1.80496 20.1668 1.33847 21.0262 1.22005 21.9466C0.730229 19.7487 2.51008 18.3277 4.73132 18.3277ZM13.9894 20.7176C16.3075 20.4305 19.46 20.6943 22.04 19.415C23.2457 18.8175 24.464 17.8146 24.464 16.4528C24.464 14.8165 22.4455 13.2035 22.4455 9.72808C22.4455 7.45841 23.4485 4.84245 26.1003 3.42144C24.4156 4.87833 23.6154 6.55054 23.6154 8.58158C23.6154 10.6126 24.4156 12.7746 27.1159 13.8368C29.0267 14.5886 30.8065 14.6137 31.5709 16.2016C30.8909 15.6633 30.0297 15.4857 29.4214 15.4857C25.5388 15.4857 24.0693 22.7487 19.5192 24.8138C20.4863 22.2929 17.5725 21.4819 14.8847 21.5411C12.6868 21.5896 9.32987 22.1871 9.29399 25.6624C8.67319 23.3336 10.0099 21.2074 13.9876 20.7176H13.9894ZM31.9548 8.94042C31.9548 8.73768 32.0751 8.3914 32.0751 8.09176C32.0751 7.93567 32.0392 7.74548 31.849 7.44764C31.5745 7.02959 31.0488 6.30114 30.5464 5.76288C29.8771 5.05776 29.2922 4.85501 28.3844 4.91422C29.1254 4.50873 29.2922 4.12656 29.2922 3.69595C29.2922 3.32634 29.0895 2.93162 28.754 2.56201C29.2312 2.64634 30.5105 3.17204 30.5105 3.86461C30.5105 4.00814 30.4387 4.13912 30.2952 4.28266L33.3651 8.12944C33.2574 8.2963 33.0188 8.22453 32.8161 8.22453C32.6851 8.22453 32.6008 8.30886 32.6008 8.4524C32.6008 8.71435 32.8035 9.03731 32.9237 9.21673C32.8286 9.27594 32.6492 9.34771 32.4572 9.34771C32.2186 9.34771 31.9548 9.26338 31.9548 8.94222V8.94042Z'
      fill='#006A4D'
    ></path>
    <path
      d='M52.2011 30.4279V15.629C52.2011 14.8015 52.0071 13.8565 51.7224 12.6785H56.4827C56.198 13.8565 56.004 14.7997 56.004 15.6272V29.999H61.2181C62.9639 29.999 64.0637 29.9207 65.2275 29.5986L64.0494 33.3766H51.7224C52.0071 32.1986 52.2011 31.2554 52.2011 30.4279Z'
      fill='black'
    ></path>
    <path
      d='M67.58 30.4278V15.6289C67.58 14.8014 67.386 13.8565 67.1013 12.6802H71.8617C71.5769 13.8583 71.383 14.8014 71.383 15.6289V30.0007H76.5971C78.3429 30.0007 79.4426 29.9224 80.6065 29.6003L79.4302 33.3784H67.1013C67.386 32.2003 67.58 31.2571 67.58 30.4296V30.4278Z'
      fill='black'
    ></path>
    <path
      d='M81.1226 23.0284C81.1226 17.1167 85.4558 12.4204 91.6914 12.4204C97.927 12.4204 102.26 17.1167 102.26 23.0284C102.26 28.9402 97.927 33.6364 91.6914 33.6364C85.4558 33.6364 81.1226 28.9402 81.1226 23.0284ZM98.4182 23.0284C98.4182 18.7592 95.8823 15.8105 91.6914 15.8105C87.5005 15.8105 84.9647 18.7592 84.9647 23.0284C84.9647 27.2976 87.5005 30.2464 91.6914 30.2464C95.8823 30.2464 98.4182 27.2976 98.4182 23.0284Z'
      fill='black'
    ></path>
    <path
      d='M109.84 25.7191C106.67 22.4856 103.915 18.0865 102.518 12.6802H106.891C106.955 13.6109 107.124 14.4651 107.473 15.4616C108.469 18.3072 109.982 20.6882 111.715 22.7063C113.5 20.779 115.143 18.3072 116.139 15.4616C116.488 14.4651 116.657 13.6127 116.721 12.6802H120.964C119.579 18.0883 116.812 22.4856 113.642 25.7191V33.3766H109.84V25.7191Z'
      fill='black'
    ></path>
    <path
      d='M124.065 30.4278V15.6289C124.065 14.8014 123.871 13.8565 123.587 12.6802H130.572C137.208 12.6802 141.398 16.9227 141.398 23.0284C141.398 29.1341 137.208 33.3766 130.572 33.3766H123.587C123.871 32.1985 124.065 31.2553 124.065 30.4278ZM137.558 23.0159C137.558 18.5278 135.01 16.056 130.314 16.056H127.868V30.0007H130.314C135.01 30.0007 137.558 27.5307 137.558 23.0159Z'
      fill='black'
    ></path>
    <path
      d='M144.011 32.2126L143.947 28.0733C146.573 29.7675 148.332 30.5434 150.376 30.5434C152.704 30.5434 154.192 29.6251 154.192 27.9683C154.192 26.8686 153.558 26.0144 151.474 25.1744L148.15 23.8415C145.084 22.6118 143.714 20.9177 143.714 18.2661C143.714 14.6821 146.508 12.4185 150.816 12.4185C153.067 12.4185 155.188 13.1303 156.418 13.7122V17.6967C154.09 16.1573 152.382 15.5238 150.636 15.5238C148.463 15.5238 147.389 16.378 147.389 17.6842C147.389 18.9904 148.074 19.6506 149.704 20.3233L153.882 22.0175C156.315 22.9998 157.906 24.7722 157.906 27.4772C157.906 31.0221 155.137 33.6345 150.209 33.6345C147.622 33.6345 145.385 32.8194 144.013 32.2108L144.011 32.2126Z'
      fill='black'
    ></path>
  </svg>
)

const Intersector = ({ children }) => {
  const someRef = useRef(null)
  const isInViewport = useIsInViewportOnce(someRef)

  return <div ref={someRef}>{isInViewport && children}</div>
}

export const HomeLloydsPage = () => {
  const { t } = useTranslation()
  const [requestDemoModalOpen, setRequestDemoModalOpen] = useState(false)
  const btn = useRef(null)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = r => {
    setAnchorEl(r.currentTarget)
  }

  const handleClose = route => {
    if (route) {
      navigate(route)
    }
    setAnchorEl(null)
  }

  const navigate = useNavigate()

  useEffect(() => {
    requestDemoModalOpen ? (document.body.style.position = 'fixed') : (document.body.style.position = 'relative')
    requestDemoModalOpen ? (document.body.style.width = '100vw') : (document.body.style.width = '100%')
  }, [requestDemoModalOpen])

  const isMobile = window.innerWidth < 769

  return (
    <>
      <Navigation
        theme={THEMES.dark}
        onOpenDemoModal={() => {
          setRequestDemoModalOpen(true)
        }}
      />
      <section className='dark heading-section lloyds'>
        <div className='hide mob-show home-mob-main-img'></div>
        <div className='container'>
          <div className='row row-center mob-column-reverse '>
            <div
              className='column column-start one-of-2 mob-fullwidth mob-text-center mob-column-center'
              style={{ maxWidth: 500 }}
            >
              <h1 className=''>Gallagher Cyber Defence Centre</h1>

              <p
                className='heading-description mw371 mom-mw305 '
                style={{ marginTop: '33px', color: '#4A4A4A', maxWidth: 500 }}
              >
                Gallagher Cyber Defence Centre is a collection of tools and services for Gallagher clients who want to
                take a proactive and continuous approach to managing their cyber risk. It includes access to cyber risk
                specialists and automated security technology to help you defend your organisation against cyber
                incidents.
              </p>

              <Button
                className='mob-fullwidth mob-font-16'
                sx={{
                  mb: 2,
                  background: '#0075BC',
                  borderRadius: 0,
                  padding: '16px 45px',
                  cursor: 'pointer',
                  color: '#fff',
                  fontSize: isMobile ? '16px' : '20px',
                  '&:hover': {
                    background: '#0c83ccff'
                  }
                }}
                ref={btn}
                onClick={handleClick}
                variant='dark'
                size='md'
              >
                Activate
              </Button>
              <Button
                className='mob-fullwidth mob-font-16'
                size='md'
                onClick={() => setRequestDemoModalOpen(true)}
                variant='dark'
                sx={{
                  background: '#0075BC',
                  borderRadius: 0,
                  padding: '16px 45px',
                  cursor: 'pointer',
                  color: '#fff',
                  fontSize: isMobile ? '16px' : '20px',
                  '&:hover': {
                    background: '#0c83ccff'
                  }
                }}
              >
                Book a demo
              </Button>

              <Menu
                sx={{ '& .MuiPaper-root': { width: btn.current?.offsetWidth || '400px', maxWidth: '400px' } }}
                id='basic-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose()}
                slotProps={{
                  list: {
                    'aria-labelledby': 'basic-button'
                  }
                }}
              >
                <MenuItem onClick={() => handleClose('/activate/uk')}>UK</MenuItem>
                <MenuItem onClick={() => handleClose('/activate/eu')}>EU</MenuItem>
                <MenuItem onClick={() => handleClose('/activate/us')}>US</MenuItem>
                <MenuItem onClick={() => handleClose('/activate/se')}>Sweden</MenuItem>
                <MenuItem onClick={() => handleClose('/activate/ch')}>Switzerland</MenuItem>
                <MenuItem onClick={() => handleClose('/activate/in')}>India</MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </section>
      <section className='header-to-dark darker padding140-150 mob-padding-54-35 box-shadow'>
        <div className='container'>
          <div className='column column-center'>
            <h2 className='text-center mb100 mob-mb-73 mw900 mob-mw341 mob-sato-26'>{t('home.setction2title')}</h2>
          </div>
          <div className='row space-between mob-column mob-margin-0'>
            <div className='column column-start one-of-4 mob-fullwidth mob-mb-40' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                {' '}
                <Intersector>
                  <CountUp end={93} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw279'>{t('home.setction2text1')}</p>
            </div>

            <div className='column column-start one-of-4 mob-fullwidth mob-mb-40' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                <Intersector>
                  <CountUp end={82} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw339 mob-mw299'>{t('home.setction2text2')}</p>
            </div>

            <div className='column column-start one-of-4 mob-fullwidth mob-mb-20' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                <Intersector>
                  <CountUp duration={3} end={30} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw279 mob-mw245'>{t('home.setction2text3')}</p>
            </div>

            <div className='column column-start one-of-4 mob-fullwidth mob-mb-20' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                <Intersector>
                  $<CountUp duration={3} end={4} />
                  .45M
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw279 mob-mw245'>{t('home.setction2text4')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className='dark pt90 pb50'>
        <div className='container'>
          <div className='column'>
            <div className=' mb40 mob-mb-20 content-box secure-humans-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 230 }}></div>
                <Spacer />
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Building Cyber Resilience Together
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                    The biggest contributor to a cyber incident is human vulnerability. Each month we will host a series
                    of cybersecurity training webinars designed for your employees at all levels of understanding.
                    Throughout the year, your staff can be trained by our specialist cybersecurity team in the role they
                    can play in defending your organisation. Topics will include boundary control, email security and
                    phishing, working from home, data protection and more.
                  </p>
                </div>
              </div>
            </div>

            <div className='row mob-column' style={{ gap: 40, marginBottom: 40 }}>
              <div className='  content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column'>
                  <div className=' '>
                    <h3 style={{ fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Continuous Vulnerability Scanning
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      Our Cyber Defence team will monitor your external boundaries and provide you updates as to the
                      known vulnerabilities with your technology portfolio. This report will outline where your low,
                      medium and high risk technology vulnerabilities reside.
                    </p>
                  </div>
                </div>
              </div>

              <div className='  content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column-reverse'>
                  <div className=' '>
                    <h3 style={{ fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Threat Intelligence Webinars
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      Forewarned is forearmed. As a cyber-insurance broker we deal with a huge amount of claims, and
                      from this, we gain extensive intelligence on the latest threats and methods of attack. We can
                      provide real-time updates on where your organisation needs to be focusing its cyber defence
                      efforts.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box newsletter-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 260 }}></div>
                <div className='mob-mb-20 one-of-2 mob-fullwidth mob-content-box-text'>
                  <h3 style={{ fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Gallagher Cyber Risk Matters Newsletter
                  </h3>
                  <div className='title-underline'></div>
                  <p
                    className='font18-400  mob-mb-20'
                    style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3', maxHeight: 508 }}
                  >
                    We will send you regular email updates on the latest cyber thinking so that you can stay informed.
                    We are in the age of information, and these key insights can support you to make key changes and
                    adaptions to your security efforts.
                  </p>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box virtual-cisco-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 230 }}></div>
                <Spacer />
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Virtual CISO
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                    Gain access to a Virtual Chief Information Security Officer (CISO) who will provide guidance and
                    support. Leverage their expertise to assess your current cybersecurity posture, develop strategies,
                    and address any concerns or questions you may have.
                  </p>
                </div>
              </div>
            </div>

            <div className='row mob-column' style={{ gap: 40, marginBottom: 40 }}>
              <div className='content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column'>
                  <div className=' mob-fullwidth'>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Cyber Essentials
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      Through Gallagher, you can take advantage of lower prices on Cyber Essentials and IASME
                      accreditation. Cyber Essentials is the government-backed information security standard that offers
                      70+ controls to better secure your network.
                    </p>
                  </div>
                </div>
              </div>

              <div className='content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column-reverse'>
                  <div className=' mob-fullwidth'>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Community Intelligence
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      You will be part of a community of security professionals where your contribution counts. You will
                      be invited to monthly discussions about key security concerns and live threats your organisation
                      needs to be aware of. We will be bringing forward thought leadership and solutions for network
                      configuration, technology optimisation, risk management and risk transfer. As a collective, we are
                      stronger together in the offensive efforts against cyber criminals.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box other-services-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 270 }}></div>
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Other Security Services
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                    Take advantage of the wider security services the Gallagher Cyber Risk Management Practice provides,
                    and receive preferential pricing as a Gallagher Cyber Defence Centre member. Services such as
                    penetration testing, phishing simulations, ISO27001, incident response planning, maturity
                    assessments and more, are all available to you when you become part of our community.
                  </p>
                </div>
                <Spacer />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='dark mob-pb-20'>
        <PromoBlock withMenu buttonText={'Activate'}>
          <p className='sato34 mb36 font500 mob-mw263 mob-font-24 text-center'>
            Start your journey with Gallagher.
            <br /> Connect with an expert.
          </p>
        </PromoBlock>
      </section>

      <Footer theme={THEMES.dark} />

      <Dialog
        sx={{ '& .MuiPaper-root': { width: 500 } }}
        onClose={() => setRequestDemoModalOpen(false)}
        open={requestDemoModalOpen}
      >
        <div className='row' style={{ padding: '10px 10px 0px 0px' }}>
          <Spacer />
          <IconButton onClick={() => setRequestDemoModalOpen(false)}>
            <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M6.92358 6.75391L19.4236 19.2539' stroke='#444444' strokeWidth='1.75' strokeLinecap='round' />
              <path d='M6.92358 19.2461L19.4236 6.7461' stroke='#444444' strokeWidth='1.75' strokeLinecap='round' />
            </svg>
          </IconButton>
        </div>
        <Form onClose={() => setRequestDemoModalOpen(false)} />
      </Dialog>
    </>
  )
}
